function removeEmojis(text) {
  return text.replace(
    /([\u{1F600}-\u{1F6FF}]|[\u{1F300}-\u{1F5FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}])/gu,
    ''
  );
}

export default {
  inserted(el) {
    const input = ['INPUT', 'TEXTAREA'].includes(el.tagName)
      ? el
      : el.querySelector('input, textarea');

    if (!input) return;

    input.addEventListener('input', () => {
      const clean = removeEmojis(input.value);
      if (clean !== input.value) {
        input.value = clean;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
};